import { render, staticRenderFns } from "./baobao1.vue?vue&type=template&id=7cf904fe&"
import script from "./baobao1.vue?vue&type=script&lang=js&"
export * from "./baobao1.vue?vue&type=script&lang=js&"
import style0 from "./baobao1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports